// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3HaDz","footer":"ModalError_footer__2hkOf"};